'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Plus } from 'lucide-react';
import { cn } from '../../utils/cn';
/**
 * Small "+ Add" button for the header row of a repeating list inside a form
 * (mobile numbers, sub agents, billing names, vehicles...).
 * type="button" so it never submits the surrounding form.
 */
export function AddButton({ onClick, label = 'Add', title, disabled, className }) {
    return (_jsxs("button", { type: "button", onClick: onClick, disabled: disabled, title: title, "aria-label": title, className: cn('inline-flex items-center gap-1 h-7 px-2.5 text-xs font-medium rounded-md border transition-colors', 'bg-primary-50 text-primary-600 border-primary-200 hover:bg-primary-100', 'dark:bg-primary-900/20 dark:text-primary-400 dark:border-primary-700 dark:hover:bg-primary-900/40', 'disabled:opacity-50 disabled:cursor-not-allowed', className), children: [_jsx(Plus, { className: "w-3.5 h-3.5" }), label] }));
}
